import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { HELP_CENTER } from '../../utils/constants';
import { toggleHelpcenterNotification } from '../../redux/actions/notification-action/notification-action';
import { EventNames, FLOW_TYPE, LOG_TYPE } from '../../utils/events/eventsConstants';
import { logEvent } from '../../utils/events/logUserEvents';
import { UNREAD_INDICATOR_ICON } from '@Images';

const HelpcenterNavSwitch = ({
  help_center_notification,
  toggleHelpcenterNotification,
  cleverTapEvent
}) => {
  const onHelpCenterClick = (_e) => {
    cleverTapEvent('helpCentre');
    const ctData = {
      pageName: FLOW_TYPE.PORFILE_SECTION_HELP_CENTER
    };
    logEvent(
      EventNames.PROFILE_SECTION_HELP_CENTER,
      FLOW_TYPE.PORFILE_SECTION_HELP_CENTER,
      ctData,
      LOG_TYPE.CLEVER_TAP
    );
    toggleHelpcenterNotification({ help_center_notification: false });
    if (window.location.pathname === HELP_CENTER) {
      window.location.reload();
    }
  };

  return (
    <>
      <Link to={HELP_CENTER} className="head" onClick={onHelpCenterClick}>
        Help centre
      </Link>
      {help_center_notification && (
        <img style={{ paddingRight: '5px' }} src={UNREAD_INDICATOR_ICON} alt="Unread Indicator" />
      )}
    </>
  );
};

HelpcenterNavSwitch.propTypes = {
  help_center_notification: PropTypes.bool,
  toggleHelpcenterNotification: PropTypes.func,
  cleverTapEvent: PropTypes.func,
  dispatch: PropTypes.func
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userDataReducer: { helpCenterNotificationData }
    }
  } = reduxState;
  return {
    help_center_notification: helpCenterNotificationData?.help_center_notification
  };
}

export default connect(mapStateToProps, {
  toggleHelpcenterNotification
})(HelpcenterNavSwitch);
